import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { capitalize } from 'lodash-es';

import type { IImageConfig } from 'components/atoms/image/entities/types';
import { ImageComponent } from 'components/atoms/image/image.component';
import { imageConfig } from 'components/organisms/header-v2/partials/header-v2-logo/entities/const';
import { KlaxoonLogoComponent } from 'components/organisms/header-v2/partials/header-v2-logo/partials/klaxoon-logo/klaxoon-logo.component';
import { WrikeLogoComponent } from 'components/organisms/header-v2/partials/header-v2-logo/partials/wrike-logo/wrike-logo.component';
import { HeaderViewService } from 'components/organisms/header-v2/service/header-view.service';
import { LocaleService } from 'src/services/locale/locale.service';
import { getDefaultTheme } from 'src/shared/helpers/get-default-theme/get-default-theme';
import type { TFullColorScheme, THeaderLayoutTheme } from 'src/shared/types/color-schemes-and-themes';
import { EProductType } from 'src/shared/types/product-type';
import { PRODUCT_TYPE } from 'src/tokens/product-type/product-type';

@Component({
    selector: 'website-header-v2-logo',
    templateUrl: './header-v2-logo.component.html',
    styleUrls: ['./header-v2-logo.component.scss'],
    imports: [ImageComponent, WrikeLogoComponent, KlaxoonLogoComponent],
})
export class HeaderV2LogoComponent {
    readonly headerViewService = inject(HeaderViewService);
    private readonly localeService = inject(LocaleService);
    private readonly productType = inject(PRODUCT_TYPE);
    public readonly brandTitle = capitalize(this.productType);
    public readonly isWrike = this.productType === EProductType.Wrike;
    public readonly isKlaxoon = this.productType === EProductType.Klaxoon;

    public readonly isDarkTheme = signal(false);

    constructor() {
        this.headerViewService.theme$
            .pipe(takeUntilDestroyed())
            .subscribe((theme: TFullColorScheme | THeaderLayoutTheme) => {
                const headerColorScheme: TFullColorScheme =
                    theme === 'light' ? 'white' : theme === 'dark' ? 'midnight' : (theme as TFullColorScheme);
                this.isDarkTheme.set(getDefaultTheme(headerColorScheme) === 'dark');
            });
    }

    public readonly DEFAULT_LOGO_ALT = `${this.brandTitle} logo`;
    public readonly pathToRootLocalHomePage = this.localeService.getPathToLocaleSlug() + '/';
    public readonly imageConfig: IImageConfig = imageConfig;
}
